import i18n from 'i18next';

import { PTBRResources } from './resources';

i18n.init({
  resources: {},
  lng: navigator?.language,
  fallbackLng: 'pt-BR',
});

PTBRResources();

export default i18n;
